export const environment = {
  production: true,
  // BASE_URL_IMPORT: 'http://localhost:8080',
  // BASE_URL_INITIAL_BALANCE: 'https://kastor-initial-balance-devel.herokuapp.com',
  // BASE_URL_REPORT: 'https://kastor-jsreport-staging.herokuapp.com/api/report',
  // BASE_URL_REPORTS: 'https://kastor-report-production.herokuapp.com',
  // BASE_URL_CRUD: 'https://kastor-crud-production.herokuapp.com',
  // BASE_URL_TRANSLATION: 'https://kastor-translation-production.herokuapp.com',
  // BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-proxy-production.herokuapp.com/accounting',
  // BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-production.herokuapp.com',
  // BASE_URL_COMMON_EXPENSES: 'https://kastor-common-expenses-staging.herokuapp.com',
  // BASE_URL_SSO: 'https://kastor-proxy-production.herokuapp.com/auth',
  // BASE_URL_ALERT: 'https://kastor-alert-production.herokuapp.com',
  // REALM: 'kastor',
  // KIUNGO_DOMAIN: 'kiungo.cl',
  // REALM_K3REM: 'production',
  // BASE_URL_K3REM: 'https://repositorio.kastor.cl/edificio_k3rem/ingresos/login',
  // BASE_URL_API_K3REM: 'https://kastor-payroll-production.herokuapp.com',
  // BASE_URL_MESSAGE: 'https://kastor-message-production.herokuapp.com',
  // BASE_URL_SOCKET_IO: 'https://kastor-message-production.herokuapp.com',
  // KEY_FROALA_KASTOR: 'cC8A6A5C4C2F3C-8C2H2C4C3B6B2A1C4B1D1qAJb1Nd1ZWPXDa1FQd1E==',
  // KEY_FROALA_KIUNGO: 'cC8A6A5C4C2F3C-8C2H2C4C3B6B2A1C4B1D1qAJb1Nd1ZWPXDa1FQd1E==',
  // LOGO_KASTOR: 'assets/img/Kastor-Eslogan-trazado.svg',
  // LOGO_KIUNGO: 'assets/img/Kiungo-Eslogan-trazado.svg',
  // LOGO_COMUNIDAD_KIUNGO: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-kiungo.png',
  // LOGO_COMUNIDAD_KASTOR: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-kastor.png',
  // KASTOR_ANALYTICS: 'UA-118368645-19',
  // KIUNGO_ANALYTICS: 'UA-118368645-23',
  // BASE_URL_PAYMENT_KASTOR: 'https://portaldepagos.kiungo.cl',
  // BASE_URL_PAYMENT_KIUNGO: 'https://portaldepagos.kiungo.cl',
  // S3_BASE_URL: 'https://s3.amazonaws.com/',
  // S3_BUCKET: 'kstk3',
  // BASE_URL_KHIPU: 'https://kastor-api-khipu-production.herokuapp.com',
  // HELP_CENTER_URL: 'https://centrodeayuda.kastorsoftware.cl/',
  // APP: 'kastor-web2-production',
  // BASE_URL_MERCADOPAGO: 'https://kastor-mercadopago-production.herokuapp.com',
  BASE_URL_REPORTS: 'https://kastor-reports-legacy.kastorsoftware.cl',
  BASE_URL_CRUD: 'https://kastor-crud-legacy.kastorsoftware.cl',
  BASE_URL_TRANSLATION: 'https://kastor-translation-legacy.kastorsoftware.cl',
  BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-proxy-legacy.kastorsoftware.cl/accounting',
  BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-legacy.kastorsoftware.cl',
  BASE_URL_SSO: 'https://kastor-proxy-legacy.kastorsoftware.cl/auth',
  BASE_URL_ALERT: 'https://kastor-alert-legacy.kastorsoftware.cl',
  REALM: 'kastor',
  KIUNGO_DOMAIN: 'kiungo.cl',
  REALM_K3REM: 'production',
  BASE_URL_K3REM: 'https://repositorio.kastor.cl/edificio_k3rem/ingresos/login',
  BASE_URL_API_K3REM: 'https://kastor-payroll-legacy.kastorsoftware.cl',
  BASE_URL_MESSAGE: 'https://kastor-message-legacy.kastorsoftware.cl',
  BASE_URL_SOCKET_IO: 'https://kastor-message-legacy.kastorsoftware.cl',
  KEY_FROALA_KASTOR: 'cC8A6A5C4C2F3C-8C2H2C4C3B6B2A1C4B1D1qAJb1Nd1ZWPXDa1FQd1E==',
  KEY_FROALA_KIUNGO: 'cC8A6A5C4C2F3C-8C2H2C4C3B6B2A1C4B1D1qAJb1Nd1ZWPXDa1FQd1E==',
  LOGO_KASTOR: 'assets/img/Kastor-Eslogan-trazado.svg',
  LOGO_KIUNGO: 'assets/img/Kiungo-Eslogan-trazado.svg',
  LOGO_COMUNIDAD_KIUNGO: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-kiungo.png',
  LOGO_COMUNIDAD_KASTOR: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-kastor.png',
  KASTOR_ANALYTICS: 'UA-118368645-19',
  KIUNGO_ANALYTICS: 'UA-118368645-23',
  BASE_URL_PAYMENT_KASTOR: 'https://portaldepagos.kastor.cl',
  BASE_URL_PAYMENT_KIUNGO: 'https://portaldepagos.kiungo.cl',
  S3_BASE_URL: 'https://s3.amazonaws.com/',
  S3_BUCKET: 'kstk3',
  BASE_URL_KHIPU: 'https://kastor-api-khipu-develop.herokuapp.com',
  BASE_URL_MERCADOPAGO: 'https://kastor-mercadopago-production.herokuapp.com',
  HELP_CENTER_URL: 'https://centrodeayuda.kastorsoftware.cl/',
  APP: 'kastor-web-production',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts